import HiringAnswers from '@/modules/common/hiring/models/APP/HiringAnswers'
import { PetHiring } from './PetHiring'
import Insured from '@/modules/common/common/models/APP/Insured'
import { needsCivilLiabilityForm } from '../../utils'

export default class PetsHiringAnswers extends HiringAnswers<Insured> {
  pets: PetHiring[]
  isLiabilityInsuredPolicyholder: boolean | undefined
  policyHolder: Insured
  /** asegurado de Responsabilidad Civil a guardar, la responsabilidad civil de todas las mascotas irá asociada a un único asegurado de RC. Cuando el titular coincide con el asegurado de RC solo será obligatorio informar el campo isPolicyHolder a True y no se tendrá en cuenta el resto de campos */
  civilLiabilityInsured: Insured
  currentPetIndex: number

  constructor(data: any = {}) {
    super(data)

    this.insureds = [] // we don't have insureds prop for pets
    this.pets = data.pets?.map((p: any) => new PetHiring(p)) ?? []
    this.isLiabilityInsuredPolicyholder = data.isLiabilityInsuredPolicyholder
    this.policyHolder = new Insured(data.policyHolder)
    this.civilLiabilityInsured = new Insured(data.civilLiabilityInsured)
    this.currentPetIndex = data.currentPetIndex ?? 0
  }

  get currentInsured() {
    return this._insureds?.[0]
  }

  set currentInsured(value: Insured) {
    this._insureds = [value]
  }

  get insureds(): Insured[] {
    return this._insureds
  }

  set insureds(value: Insured[]) {
    this._insureds = value?.map((i) => new Insured(i)) ?? []
  }

  get holder(): Insured {
    return this._insureds?.[0]
  }

  set holder(value: Insured | undefined) {
    this._holder.updateAttributes(value ?? {})
  }

  get policyHolderPostal() {
    return this.policyHolder.addressDetails?.postalCode
  }

  updatePetAttributes(index: number, insuredData: Partial<PetHiring>) {
    this.pets[index].updateAttributes(insuredData)
  }

  isDocumentNumberAvailable(number: string, riskNumber: number, role: string): boolean {
    if (
      this.policyHolder.riskNumber !== riskNumber &&
      this.policyHolder.addressDetails &&
      this.policyHolder.documentDetails.documentNumber === number
    ) {
      return false
    }

    if (
      this.policyHolder.documentDetails.documentNumber === number &&
      role !== this.policyHolder.role
    )
      return false
    return true
  }

  needsCivilLiabilityStep() {
    return !!this.pets.find((p) => needsCivilLiabilityForm(p.coverages))
  }

  hasBetterAssurance() {
    return this.needsCivilLiabilityStep()
  }

  hasAnotherCompany() {
    return !!this.pets.find((pet) => pet.hasAccidentInsurance || pet.hasRcInsurance)
  }
}
